const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/intelligence/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type ContentIntelligenceBeforeLoadArgs = {
  context: PermissionContext & {
    flags: {
      tempoContentIntelligenceEnabled: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};
export const contentIntelligenceBeforeLoad = async (args: ContentIntelligenceBeforeLoadArgs) => {
  await requirePermission('view_loop')(args);
  if (!args.context.flags.tempoContentIntelligenceEnabled) {
    throw redirect({
      to: '/org/$org/loop/$loopId/overview',
      params: args.params,
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/intelligence/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: contentIntelligenceBeforeLoad,
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.contentIntelligence.title)
    }
  }
});